module.exports = __webpack_public_path__ + "img/Local-Clips-Option-2.c793a7b0.png";